/**
 * Returns the appropriate Font Awesome icon class for a Cury device slot.
 *
 * This function maps slot positions to their corresponding directional arrow icons
 * for use in the UI. It provides visual indicators for left and right slots on
 * the Cury device.
 *
 * @param {string} slot - The slot position identifier ('left' or 'right')
 *
 * @returns {string} The Font Awesome CSS class for the slot icon:
 *   - 'fas fa-arrow-left' for 'left' slot
 *   - 'fas fa-arrow-right' for 'right' slot or any other value
 *
 * @example
 * // Get icon for left slot
 * const leftIcon = getSlotIcon('left');
 * console.log(leftIcon); // 'fas fa-arrow-left'
 *
 * @example
 * // Get icon for right slot
 * const rightIcon = getSlotIcon('right');
 * console.log(rightIcon); // 'fas fa-arrow-right'
 *
 */
export const getSlotIcon = (slot: string): string => {
	return slot === 'left' ? 'fas fa-arrow-left' : 'fas fa-arrow-right';
};
